// frontend/src/Components/common/ErrorDialog.jsx
import React from 'react';
import './ErrorDialog.css';

/**
 * Komponent do wyświetlania błędów w czytelny sposób
 */
export const ErrorDialog = ({ error, isOpen, onClose, title = "Błąd" }) => {
  if (!isOpen || !error) return null;

  // Funkcja do otrzymania czytelnego komunikatu błędu
  const getErrorMessage = (error) => {
    if (!error) return "Nieznany błąd";
    
    // Błędy z NestHub (przez Django)
    if (error.response?.data?.status === "error") {
      const errorCode = error.response.data.error_code;
      const message = error.response.data.message;
      
      switch (errorCode) {
        case "ALREADY_PAIRED":
          return "Ta drukarka jest już sparowana z tym hubem";
        case "AUTH_FAILED":
          return "Nieprawidłowy kod dostępu. Sprawdź kod i spróbuj ponownie";
        case "CONNECTION_FAILED":
          return "Nie można połączyć się z drukarką. Sprawdź adres IP i upewnij się, że drukarka jest włączona";
        case "TIMEOUT":
          return "Przekroczono czas oczekiwania na odpowiedź drukarki. Sprawdź połączenie sieciowe";
        case "CONNECTION_ERROR":
          return "Błąd połączenia z drukarką. Sprawdź ustawienia sieciowe";
        case "PAIRING_ERROR":
          return "Wystąpił błąd podczas parowania drukarki";
        default:
          return message || "Nieoczekiwany błąd podczas parowania";
      }
    }
    
    // Błędy sieciowe
    if (error.message) {
      if (error.message.includes("Unauthorized")) {
        return "Brak autoryzacji. Zaloguj się ponownie";
      }
      if (error.message.includes("timeout")) {
        return "Przekroczono czas oczekiwania na odpowiedź";
      }
      if (error.message.includes("Network Error")) {
        return "Błąd sieci. Sprawdź połączenie internetowe";
      }
      return error.message;
    }
    
    return "Wystąpił nieoczekiwany błąd";
  };

  // Funkcja do otrzymania ikony błędu
  const getErrorIcon = (error) => {
    const errorCode = error.response?.data?.error_code;
    
    switch (errorCode) {
      case "ALREADY_PAIRED":
        return "⚠️";
      case "AUTH_FAILED":
        return "🔐";
      case "CONNECTION_FAILED":
      case "CONNECTION_ERROR":
        return "🔌";
      case "TIMEOUT":
        return "⏰";
      default:
        return "❌";
    }
  };

  // Funkcja do otrzymania sugestii rozwiązania
  const getErrorSuggestion = (error) => {
    const errorCode = error.response?.data?.error_code;
    
    switch (errorCode) {
      case "ALREADY_PAIRED":
        return "Spróbuj usunąć sparowanie i sparuj ponownie";
      case "AUTH_FAILED":
        return "Sprawdź kod dostępu w ustawieniach drukarki";
      case "CONNECTION_FAILED":
      case "CONNECTION_ERROR":
        return "Upewnij się, że drukarka jest włączona i połączona z tą samą siecią";
      case "TIMEOUT":
        return "Spróbuj ponownie za chwilę lub sprawdź połączenie";
      default:
        return "Sprawdź ustawienia i spróbuj ponownie";
    }
  };

  const errorMessage = getErrorMessage(error);
  const errorIcon = getErrorIcon(error);
  const errorSuggestion = getErrorSuggestion(error);

  return (
    <div className="error-dialog-overlay" onClick={onClose}>
      <div className="error-dialog" onClick={e => e.stopPropagation()}>
        <div className="error-dialog-header">
          <h3>
            <span className="error-icon">{errorIcon}</span>
            {title}
          </h3>
          <button className="error-dialog-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="error-dialog-content">
          <div className="error-message">
            {errorMessage}
          </div>
          
          {errorSuggestion && (
            <div className="error-suggestion">
              <strong>Sugestia:</strong> {errorSuggestion}
            </div>
          )}
          
          {error.response?.data?.error_code && (
            <div className="error-code">
              Kod błędu: {error.response.data.error_code}
            </div>
          )}
        </div>
        
        <div className="error-dialog-actions">
          <button className="error-dialog-button" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDialog;
